import FinancialsTemplateFieldsFragment from "components/financials/modern/graphql/fragments/FinancialsTemplateFieldsFragment";
import gql from "graphql-tag";

export default gql`
  mutation ChangeFinancialsTemplateVisibility(
    $objectId: FinancialsTemplateID!
    $input: ChangeFinancialsTemplateVisibilityInput!
  ) {
    changeFinancialsTemplateVisibility(objectId: $objectId, input: $input) {
      ...FinancialsTemplateFields
    }
  }

  ${FinancialsTemplateFieldsFragment}
`;
